import {
  START_SIMULATOR,
  SUCCESS_SIMULATOR,
  ERROR_SIMULATOR,
} from "Actions/SimulatorAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import { createSimulatorAPI } from "Api/SimulatorApi";
import { call, put, takeEvery } from "redux-saga/effects";

function* createSimulatorWorker({ payload, appendData }) {
  try {
    const res = yield call(createSimulatorAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_SIMULATOR,
        payload: res,
        appendData,
      });
    } else {
      yield put({
        type: ERROR_SIMULATOR,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.message,
          type: "error",
        },
      });
    }
  } catch (error) {}
}

export function* SimulatorSaga() {
  yield takeEvery(START_SIMULATOR, createSimulatorWorker);
}
